import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300" itemScope itemType="https://schema.org/Organization">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/images/favicon.webp" alt="Lyon Picks" itemProp="logo" width="32" height="32" className="h-8 w-8" loading="lazy" />
              <h3 className="text-white text-xl font-bold" itemProp="name">Lyon Picks</h3>
            </div>
            <p className="text-sm leading-relaxed" itemProp="description">
              Votre guide indépendant pour comparer les meilleures offres de paris en ligne en France.
            </p>
            <div itemScope itemType="https://schema.org/ContactPoint" className="mt-4">
              <meta itemProp="email" content="info@lyonpicks.com" />
              <meta itemProp="telephone" content="+33-2-89-85-87-16" />
              <meta itemProp="contactType" content="customer service" />
            </div>
            <div itemScope itemType="https://schema.org/PostalAddress" className="mt-2">
              <meta itemProp="addressLocality" content="Paris" />
              <meta itemProp="addressCountry" content="FR" />
            </div>
          </div>
          
          






          <div className="space-y-3 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Navigation</p>
            <Link to="/" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Accueil</Link>
            <Link to="/guides" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Guides</Link>
            <Link to="/reviews" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Avis</Link>
            <Link to="/news" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Actualités</Link>
          </div>
          <div className="space-y-3 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Légal</p>
            <Link to="/privacy-policy" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Politique de confidentialité</Link>
            <Link to="/terms" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Conditions générales</Link>
            <Link to="/cookies" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Politique cookies</Link>
            <Link to="/responsible-gaming" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Jeu responsable</Link>
          </div>
          <div className="space-y-4 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Jeu responsable</p>
            <div className="grid grid-cols-2 gap-3">
              <a
                  href="https://www.anj.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/logo-anj.svg" alt="ANJ - Autorité Nationale des Jeux" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.evalujeu.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/evalu.svg" alt="EvaluJeu" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.sosjoueurs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/sos.svg" alt="SOS Joueurs" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.sosjoueurs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/18+.svg" alt="18+" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
            </div>
        </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8">
          <div className="text-sm leading-relaxed space-y-2">
            <p className="text-gray-400">
              Lyon Picks est un site indépendant de comparaison et d'évaluation. Certains liens présents sur nos pages sont des liens d'affiliation, 
              ce qui signifie que nous pouvons recevoir une commission si vous cliquez ou vous inscrivez via ces liens. Cela n'affecte jamais nos opinions, 
              nos évaluations ou nos recommandations. Réservé aux personnes de 18 ans et plus. Jouez de manière responsable - consultez BeGambleAware.org. 
              Les conditions générales s'appliquent.
            </p>
            <p className="text-gray-500 text-xs mt-4">
              © {new Date().getFullYear()} Lyon Picks. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

